module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-one.714f6cbb.png";